// extracted by mini-css-extract-plugin
export default {"error":"error_pNUFA","errorContent":"errorContent_RNSfa","errorMessage":"errorMessage_JPTq0","backButton":"backButton_bVF1q"};